function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLogout = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2455",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.414,
    height: 25,
    viewBox: "0 0 24.414 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0srvyxruna"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5661",
    style: {
      fill: "none"
    },
    d: "M0 0h24.414v25H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2454",
    style: {
      clipPath: "url(#0srvyxruna)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3874",
    d: "M8.558 25H3.655a3.271 3.271 0 0 1-1.662-.452A3.7 3.7 0 0 1 0 21.115V3.7A3.738 3.738 0 0 1 3.653.013C5.467 0 6.694 0 7.888 0c1.295 0 2.566 0 4.512.011a3.741 3.741 0 0 1 3.591 3.02 13.286 13.286 0 0 1 .086 3.17l-.011.214a.863.863 0 0 1-.875.846 1.012 1.012 0 0 1-.538-.16.992.992 0 0 1-.438-.916c0-.169 0-.338-.008-.507-.01-.568-.02-1.154.012-1.722a1.911 1.911 0 0 0-.525-1.456 2.165 2.165 0 0 0-1.547-.664h-.015c-1.418.011-2.542.016-3.759.016H3.95a1.955 1.955 0 0 0-2.1 2.1v17.132a1.934 1.934 0 0 0 2.013 2.066h8.373a1.921 1.921 0 0 0 1.973-1.963v-2.424a2.828 2.828 0 0 1 .028-.612.966.966 0 0 1 .909-.811h.046a.891.891 0 0 1 .883.857c.005.211.012.423.019.635a18.67 18.67 0 0 1-.057 2.878 3.763 3.763 0 0 1-3.637 3.281C10.789 25 9.641 25 8.558 25",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3875",
    d: "M73.994 68.517a.9.9 0 0 1-.655-.3.873.873 0 0 1 .028-1.3c.48-.486.954-.956 1.457-1.454l.934-.928-.327-.211a.708.708 0 0 0-.4-.113H63.662a1.011 1.011 0 0 1-.846-.4.919.919 0 0 1-.1-.857.893.893 0 0 1 .865-.59H75.42l.217-.464-.608-.594q-.452-.441-.9-.884c-.27-.266-.5-.488-.723-.724a.939.939 0 0 1 .587-1.636.976.976 0 0 1 .679.31c1.5 1.468 2.875 2.835 4.206 4.178a.98.98 0 0 1-.061 1.543q-1.348 1.349-2.7 2.692l-1.082 1.076-.1.1c-.1.1-.181.182-.27.264a.987.987 0 0 1-.669.284",
    transform: "translate(-54.809 -50.796)",
    style: {
      fill: "#1a1818"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-logout.f2d3d57028209ff04e159a0e7e4bfdba.svg";